import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Dashboard';

import MASTERS_COMMON_MST_APP from '../pages/masters/Common_Masters/Common_MstApp';
// import MASTERS_SOCIETY_MST_APP from '../pages/masters/Society_Master/SctyMstApp';
import MASTERS_INSTITUTE_MST_APP from '../pages/School_Master/Inst_Master/InstituteApp';
import MASTERS_SECTION_APP from '../pages/School_Master/Section/SectionApp';
import MASTERS_STD_DIV from '../pages/School_Master/Std_Div/Std_DivApp';
//import STUD_MODULE_ADD_STUDENT from '../pages/Student_Module/Student_Add/Student_AddApp';
import STUD_MODULE_NEW_STUDENT from '../pages/Student_Module/Student_Master/New/NewStudentApp';
import EDIT_STUDENT from '../pages/Student_Module/Student_Master/Edit/EditStudentApp';
import VIEW_STUDENT from '../pages/Student_Module/Student_Master/View/ViewStudentApp';

import GENERATE_ROLLNO from '../pages/Student_Module/Generate_RollNo/Generate_RollNoApp';

import LIST_STUDENTS from '../pages/Student_Module/Reports/List_Students/ListStudApp';
import STUD_MEDIC_RPT from '../pages/Student_Module/Reports/Student_Medical/MedicalRecApp';

import LIST_ROLLNO from '../pages/Student_Module/Reports/List_RollNo/ListRollNoApp';


import LC_MODULE_GEN_LC from '../pages/Student_Module/LC_Module/Leave_Cert/Leave_CertApp';
import LC_MODULE_BULK_LC from '../pages/Student_Module/LC_Module/Bulk_LC/BulkLeaveCertApp';
import FEES_MODULE_FEES_DESCRIPTION from '../pages/Fees_Module/Master/Fees_Desc/Fees_DescApp';
import CLASS_FEE_STRUCTURE from '../pages/Fees_Module/Master/Class_Fee_Struct/ClassFeeStructApp';
import DISC_LATEFEES_DATE from '../pages/Fees_Module/Master/Disc_LateFees_Date/DiscLFDateApp';
import HOD_WAIVER_LMT from '../pages/Fees_Module/Fees_Waiver/HOD_WaiverLmt/HODWaiverLmtApp';
import DEF_FEES_WAIVER from '../pages/Fees_Module/Fees_Waiver/Define_Waiver/FeeWaiverApp';
import FEE_WAIVER_ALLOC from '../pages/Fees_Module/Fees_Waiver/Fee_Waiver_Allocation/FeeWaiverAllocationApp';
import APPR_FEE_WAIVER from '../pages/Fees_Module/Fees_Waiver/Appr_FeeWaiver/ApprFeeWaiverApp';
import HOD_WAIVER_APPR from '../pages/Fees_Module/Fees_Waiver/HODWaiverAppr/HODWaiverApprApp';
import REVOKE_FW from '../pages/Fees_Module/Fees_Waiver/Revoke_Fee_Waiver/Revoke_FWApp';
import RPT_DAILY_FEE_REG from '../pages/Fees_Module/Reports/Daily_Fee_Register/DailyFeeRegApp';
import RPT_MTHLY_FEE_REG from '../pages/Fees_Module/Reports/Mthly_Fee_Register/MthlyFeeRegApp';
import RPT_PEND_FEES from '../pages/Fees_Module/Reports/Pending_Fees/PendingFeesApp';
import RPT_CLASS_FS from '../pages/Fees_Module/Reports/Rpt_Classwise_FS/RptClassFSApp';
import RPT_FW_LISTING from '../pages/Fees_Module/Reports/Rpt_FW_Listing/RptFWListingApp';
import RPT_ALLOCATE_FW from '../pages/Fees_Module/Reports/Rpt_Allocated_FW/RptAllocatedFWApp';

import FEE_COLLECTION from '../pages/Fees_Module/Transaction/Fee_Collection/FeeCollectionApp';
import UPD_CHQ_RCPT from '../pages/Fees_Module/Transaction/Upd_Chq_Rcpt/UpdChqRcptApp';
import EDIT_STUD_FEES from '../pages/Fees_Module/Transaction/Edit_Stud_Fees/EditStudFeesApp';
import POST_RCPT_FIN from '../pages/Fees_Module/Transaction/Finance_Posting/Post_Rcpt_FinanceApp';

import SUBJECT_APP from '../pages/Marksheet_Module/School_Master/Subjects/SubjectApp';
import CLASSWISE_SUBJECT from '../pages/Marksheet_Module/School_Master/Classwise_Subject/Classwise_SubjectApp';
import COLLAGE_SUBJECT from '../pages/Marksheet_Module/Collage_Master/Collage_Subjects/Collage_SubjectApp';
import MAND_CLASSWISE_APP from '../pages/Marksheet_Module/Collage_Master/Mand_Classwise_Sub/Mand_Classwise_SubApp';
import OPTIONAL_CLASSWISE_APP from '../pages/Marksheet_Module/Collage_Master/Opt_Classwise_sub/Opt_Classwise_SubApp';
import ATTENDANCE_APP from '../pages/Marksheet_Module/Daily_Attendance/AttendanceApp';
import ADD_SCH_MARKS_APP from '../pages/Marksheet_Module/School_Marks_Entry/Add_Marks/Add_MarksApp';
import ATTENDANCE_REMARK_APP from '../pages/Marksheet_Module/School_Marks_Entry/Attendance_Remark/Attendance_RemarkApp';
import EXAM_TIMETABLE from '../pages/Marksheet_Module/Exam/Exam_Timetable/Exam_TimetableApp';
import ASSIGN_TEACHER from '../pages/Marksheet_Module/Time_Table/Assign_Teacher/Assign_TeacherApp';
import NEW_EMP from '../pages/Payroll/Master/New_Employe/New_EmployeApp';
import EDIT_EMP from '../pages/Payroll/Master/Edit_Employee/Edit_EmployeeApp';

import GENERAL_MASTER_APP from '../pages/Payroll/General_Master/General_MasterApp';
import HOLIDAY_LIST_APP from '../pages/Payroll/Holiday_List/Holiday_List/Holiday_ListApp';
import HOLIDAY_STAFF_LIST_APP from '../pages/Payroll/Holiday_List/Holiday_Staff_List/Holiday_Staff_ListApp';
import CREATE_SHIFT_APP from '../pages/Payroll/Holiday_List/Shift_Master/Shift_MasterApp';
import LEAVES_REMUNIRATION_APP from '../pages/Payroll/Payroll_Active/Leaves_Remuniration/Leaves_RemunirationApp';
import ADDITIONAL_EARNING from '../pages/Payroll/Payroll_Active/Additional_Earning/Additional_EarningApp';
import LOANS_DEDUCTIONS from '../pages/Payroll/Payroll_Active/Loans_Deductions/Loans_DeductionApp';
import RELEASE_HOLD_SALARY from '../pages/Payroll/Payroll_Active/Release_Hold_Salary/Release_Hold_SalaryApp';
import SALARY_INCREMENT from '../pages/Payroll/Payroll_Active/Salary_Increment/Salary_IncrementApp';
import LEAVE_APPLICATION from '../pages/Payroll/Leave_Resignation/Leave_Resign/Leave_ResignApp';
import COMPENSATORY_LEAVE from '../pages/Payroll/Leave_Resignation/Compensatory_Leave/Compensatory_LeaveApp';
import PAYROLL_KPI_MASTER from '../pages/Payroll/Peformance/KPI_Master/KPI_MasterApp';
import PAYROLL_KPI_TEMPLATE from '../pages/Payroll/Peformance/KPI_Template/KPI_TemplateApp';
import PAYROLL_ASSIGN_KPI_EMP from '../pages/Payroll/Peformance/Assign_KPI_Employee/Assign_KPI_EmpApp';
import PAYROLL_EMP_KPI_ENTRY from '../pages/Payroll/Peformance/Emp_KPI_Entry/Emp_KPI_EntryApp';
import PAYROLL_SUP_KPI_UPDATE from '../pages/Payroll/Peformance/Sup_KPI_Upd/Sup_KPI_UpdApp';

import PERF_MD_HM_REVIEW from '../pages/Payroll/Peformance/MD_HM_Review/MD_HM_ReviewApp';
import PAYROLL_MD_KPI_APPROVAL from '../pages/Payroll/Peformance/MD_KPI_Approval/MD_KPI_ApprApp';
import PAYROLL_HM_KPI_APPROVAL from '../pages/Payroll/Peformance/HM_KPI_Approval/HM_KPI_ApprApp';
import PROLL_PERFORM_RPT_KPI from '../pages/Payroll/Performacne_Reports/Performance_KPI/Rpt_Perf_KPI_App';
import PP_RPT_DAILY_KPI_ENTRY from '../pages/Payroll/Performacne_Reports/Emp_Daily_KPI/Rpt_Daily_KPI_App';

import NOTICE_APP from '../pages/Mobile_App/Notice/NoticeApp';
import TIME_TABLE_APP from '../pages/Mobile_App/Time_Table/Time_TableApp';
import HOME_WORK_APP from '../pages/Mobile_App/Home_Work/Home_WorkApp';
import EVENTS_APP from '../pages/Mobile_App/Events/EventsApp';
import AWARD_APP from '../pages/Mobile_App/Awards/AwardApp';
import LEAVE_APPROVAL from '../pages/Mobile_App/Leave_Approval/Leave_ApprovApp';
import APPOINTMENT_APPROVAL from '../pages/Mobile_App/Appointment_Approval/Appointment_ApprovalApp';
import NOTES_APP from '../pages/Mobile_App/Notes/NotesApp';
import REMARK_APP from '../pages/Mobile_App/Remark/RemarkApp';
import CREATE_EXAM from '../pages/Mobile_App/Create_Exam/Create_ExamApp';
import ATTENDANCE_PERIOD_APP from '../pages/Marksheet_Module/Attendance_Period/Attendance_PeriodApp';

import USER_MASTERAPP from '../pages/user_management/user_creation/User_MasterApp';
import ROLE_MASTERAPP from '../pages/user_management/role_creation/Role_MasterApp';
import CHANGE_PASSAPP from '../pages/user_management/change_password/ChangePassApp';
import RESET_PASSAPP from '../pages/user_management/reset_user_pass/Reset_PassApp';

// import MASTERS_MAINT_COMP_APP from '../pages/masters/Maint_Comp/MaintCompApp';
// import MASTERS_PREM_TYPES_APP from '../pages/masters/Prem_Types/PremTypesApp';
// import MASTERS_OWNER_APP from '../pages/masters/Owner_Master/OwnerMstApp';

/// Master Reports
// import MAST_RPT_OWNER_APP from '../pages/masters/Reports/List_Owners/ListOwnersApp';
// import MAINT_STRUCT_APP from '../pages/Maintenance/Maint_Struct/MaintStrctApp';                              
// import MAINT_RCPT_APP from '../pages/Maintenance/Maint_Rcpt/MaintRcptApp';                                                                                                                                               
// import MAINT_POST_APP from '../pages/Maintenance/Maint_Posting/MaintPostApp';                              
// import MAINT_CANC_APP from '../pages/Maintenance/Maint_Cancel/MaintCancApp';                              
// import ADDTN_MAINT_APP from '../pages/Maintenance/Addtn_Maint/AddtnMaintApp';                                                                   
// import ALLOC_REBATE_APP from '../pages/Maintenance/Rebate_Alloc/AllocRebateApp';
// import ALLOC_PARKING_APP from '../pages/Maintenance/Parking_Alloc/AllocParkingApp';                              

// /// Maintenance Reports
// import RPT_PEND_MAINT_APP from '../pages/Maintenance/Reports/Pending_Maint/PendMaintApp';
// import RPT_MAINT_REG_APP from '../pages/Maintenance/Reports/Maint_Register/MaintRegApp';
// import LIST_MAINT_STRUCT_APP from '../pages/Maintenance/Reports/List_Maint_Struct/ListMaintStructApp';
// import RPT_ALLOT_PARK_APP from '../pages/Maintenance/Reports/Alloted_Parking/RptAllotedParkApp';

// /// Tenancy
// import RENTAL_CHRG_APP from '../pages/Tenancy/Rental_Chrg/RentChrgApp';
// import RENTAL_AGRMNT_APP from '../pages/Tenancy/Rental_Agrmt/RentAgrmtApp';

// /// Mobile App
// import MOBAPP_NOTICE from '../pages/MobileApp/Notices/NoticeApp';
// import MOB_RPT_LST_NOTICE from '../pages/MobileApp/Reports/List_Notices/ListNoticesApp';

//// Finance
import FIN_GROUP_MST_APP from '../pages/Finance/Masters/Group_Master/FinGroupApp';
import FIN_SUBGRP_MST_APP from '../pages/Finance/Masters/SubGroup_Master/SubGroupApp';
import FIN_CB_MST_APP from '../pages/Finance/Masters/CashBank_Master/CB_MasterApp';
import FIN_ACCNT_MST_APP from '../pages/Finance/Masters/Accnt_Master/AccntMasterApp';
import FIN_BDGT_MAST_APP from '../pages/Finance/Masters/Budget_Master/BdgtMastApp';

import FIN_PAY_VCHR_APP from '../pages/Finance/Transactions/Pay_Vchr/PayVchrApp';
import FIN_RCPT_VCHR_APP from '../pages/Finance/Transactions/Rcpt_Vchr/RcptVchrApp';
import FIN_JV_VCHR_APP from '../pages/Finance/Transactions/JV_Vchr/JV_VchrApp';
import FIN_CONTRA_APP from '../pages/Finance/Transactions/Contra_Vchr/ContraApp';
import FIN_BANKRECO_APP from '../pages/Finance/Transactions/Bank_Reco/bankRecoApp';
import FIN_BUDALLOC_APP from '../pages/Finance/Transactions/Budget_Alloc/BudgetAllocApp';

//// Finance Reports
import FIN_CHART_GRP_APP from '../pages/Finance/Reports/ChartGrps/ChartGrpApp';
import FIN_CHART_ACCNT_APP from '../pages/Finance/Reports/ChartAccnt/ChartAccntApp';
import FIN_DAY_BOOK_APP from '../pages/Finance/Reports/Day_Book/DayBookApp';
import FIN_CB_BOOK_APP from '../pages/Finance/Reports/CashBank_Book/CBBookApp';
import FIN_LEDGER_APP from '../pages/Finance/Reports/Ledger/LedgerApp';
import FIN_TRIALBAL_APP from '../pages/Finance/Reports/Trial_Balance/TrialBalApp';
import FIN_PL_APP from '../pages/Finance/Reports/Profit_Loss/ProfitLossApp';
import FIN_BS_APP from '../pages/Finance/Reports/Bal_Sheet/BalSheetApp';
import FIN_RPT_BGTALLOC_APP from '../pages/Finance/Reports/Budget_Alloc/RptBgtAllocApp';
import RPT_DETL_BGT_APP from '../pages/Finance/Reports/Detail_Budget/RptDtlBgtApp';

function MainPanel() {
  
  return (
    <div className="d-flex flex-column ">
      <Routes>
        <Route path="masters/Common_Masters/Common_MstApp" element={<MASTERS_COMMON_MST_APP />}/>
        {/* <Route path="masters/Society_Master/SctyMstApp" element={<MASTERS_SOCIETY_MST_APP />}/> */}

        <Route path="School_Master/Inst_Master/InstituteApp" element={<MASTERS_INSTITUTE_MST_APP />}/>
        <Route path="School_Master/Section/SectionApp" element={<MASTERS_SECTION_APP />}/>
        <Route path="School_Master/Std_div/Std_DivApp" element={<MASTERS_STD_DIV />}/>
        {/* <Route path="Student_Module/Student_Add/Student_AddApp" element={<STUD_MODULE_ADD_STUDENT />}/> */}
        <Route path="Student_Module/Student_Master/New/NewStudentApp" element={<STUD_MODULE_NEW_STUDENT />}/>
        <Route path="Student_Module/Student_Master/Edit/EditStudentApp" element={<EDIT_STUDENT />}/>
        <Route path="Student_Module/Student_Master/View/ViewStudentApp" element={<VIEW_STUDENT />}/>

        <Route path="Student_Module/Generate_RollNo/Generate_RollNoApp" element={<GENERATE_ROLLNO />}/>

        <Route path="Student_Module/Reports/List_Students/ListStudApp" element={<LIST_STUDENTS />}/>
        <Route path="Student_Module/Reports/Student_Medical/MedicalRecApp" element={<STUD_MEDIC_RPT />}/>

        <Route path="Student_Module/Reports/List_RollNo/ListRollNoApp" element={<LIST_ROLLNO />}/>

        <Route path="Student_Module/LC_Module/Leave_Cert/Leave_CertApp" element={<LC_MODULE_GEN_LC />}/>
        <Route path="Student_Module/LC_Module/Bulk_LC/BulkLeaveCertApp" element={<LC_MODULE_BULK_LC />}/>
        <Route path="Fees_Module/Master/Fees_Desc/Fees_DescApp" element={<FEES_MODULE_FEES_DESCRIPTION />}/>
        <Route path="Fees_Module/Master/Class_Fee_Struct/ClassFeeStructApp" element={<CLASS_FEE_STRUCTURE />}/>
        <Route path="Fees_Module/Master/Disc_LateFees_Date/DiscLFDateApp" element={<DISC_LATEFEES_DATE />}/>
        <Route path="Fees_Module/Fees_Waiver/Define_Waiver/FeeWaiverApp" element={<DEF_FEES_WAIVER />}/>
        <Route path="Fees_Module/Fees_Waiver/HOD_WaiverLmt/HODWaiverLmtApp" element={<HOD_WAIVER_LMT />}/>

        <Route path="Fees_Module/Fees_Waiver/Fee_Waiver_Allocation/FeeWaiverAllocationApp" element={< FEE_WAIVER_ALLOC />}/>
        <Route path="Fees_Module/Fees_Waiver/Appr_FeeWaiver/ApprFeeWaiverApp" element={< APPR_FEE_WAIVER />}/>
        <Route path="Fees_Module/Fees_Waiver/HODWaiverAppr/HODWaiverApprApp" element={< HOD_WAIVER_APPR />}/>
        <Route path="Fees_Module/Fees_Waiver/Revoke_Fee_Waiver/Revoke_FWApp" element={<REVOKE_FW/>}/>

        <Route path="Fees_Module/Transaction/Fee_Collection/FeeCollectionApp" element={<FEE_COLLECTION />} />
        <Route path="Fees_Module/Transaction/Upd_Chq_Rcpt/UpdChqRcptApp" element={<UPD_CHQ_RCPT />} />
        <Route path="Fees_Module/Transaction/Edit_Stud_Fees/EditStudFeesApp" element={<EDIT_STUD_FEES/>}/>
        <Route path="Fees_Module/Transaction/Finance_Posting/Post_Rcpt_FinanceApp" element={<POST_RCPT_FIN/>}/>

        <Route path="Fees_Module/Reports/Daily_Fee_Register/DailyFeeRegApp" element={<RPT_DAILY_FEE_REG />} />
        <Route path="Fees_Module/Reports/Mthly_Fee_Register/MthlyFeeRegApp" element={<RPT_MTHLY_FEE_REG />} />
        <Route path="Fees_Module/Reports/Pending_Fees/PendingFeesApp" element={<RPT_PEND_FEES />} />
        <Route path="Fees_Module/Reports/Rpt_Classwise_FS/RptClassFSApp" element={<RPT_CLASS_FS />} />
        <Route path="Fees_Module/Reports/Rpt_FW_Listing/RptFWListingApp" element={<RPT_FW_LISTING />} />
        <Route path="Fees_Module/Reports/Rpt_Allocated_FW/RptAllocatedFWApp" element={<RPT_ALLOCATE_FW />} />

        <Route path="Marksheet_Module/School_Master/Subjects/SubjectApp" element={<SUBJECT_APP/>}/>
        <Route path="Marksheet_Module/School_Master/Classwise_Subject/Classwise_SubjectApp" element={<CLASSWISE_SUBJECT/>}/>
        <Route path="Marksheet_Module/Collage_Master/Collage_Subjects/Collage_SubjectApp" element={<COLLAGE_SUBJECT/>}/>
        <Route path="Marksheet_Module/Collage_Master/Mand_Classwise_Sub/Mand_Classwise_SubApp" element={<MAND_CLASSWISE_APP/>}/>
        <Route path="Marksheet_Module/Collage_Master/Opt_Classwise_Sub/Opt_Classwise_SubApp" element={<OPTIONAL_CLASSWISE_APP/>}/>
        <Route path="Marksheet_Module/Daily_Attendance/AttendanceApp" element={<ATTENDANCE_APP/>}/>
        <Route path="Marksheet_Module/School_Marks_Entry/Add_Marks/Add_MarksApp" element={<ADD_SCH_MARKS_APP/>}/>
        <Route path="Marksheet_Module/School_Marks_Entry/Attendance_Remark/Attendance_RemarkApp" element={<ATTENDANCE_REMARK_APP/>}/>
        <Route path="Marksheet_Module/Exam/Exam_Timetable/Exam_TimetableApp" element={<EXAM_TIMETABLE/>}/>
        <Route path="Marksheet_Module/Time_Table/Assign_Teacher/Assign_TeacherApp" element={<ASSIGN_TEACHER/>}/>
        <Route path="Payroll/Master/New_Employe/New_EmployeApp" element={<NEW_EMP/>}/>
        <Route path="Payroll/Master/Edit_Employee/Edit_EmployeeApp" element={<EDIT_EMP/>}/>

        <Route path="Payroll/General_Master/General_MasterApp" element={<GENERAL_MASTER_APP/>}/>
        <Route path="Payroll/Holiday_List/Holiday_List/Holiday_ListApp" element={<HOLIDAY_LIST_APP/>}/>
        <Route path="Payroll/Holiday_List/Holiday_Staff_List/Holiday_Staff_ListApp" element={<HOLIDAY_STAFF_LIST_APP/>}/>
        <Route path="Payroll/Holiday_List/Shift_Master/Shift_MasterApp" element={<CREATE_SHIFT_APP/>}/>
        <Route path="Payroll/Payroll_Active/Leaves_Remuniration/Leaves_RemunirationApp" element={<LEAVES_REMUNIRATION_APP/>}/>
        <Route path="Payroll/Payroll_Active/Additional_Earning/Additional_EarningApp" element={<ADDITIONAL_EARNING/>}/>
        <Route path="Payroll/Payroll_Active/Loans_Deductions/Loans_DeductionApp" element={<LOANS_DEDUCTIONS/>}/>
        <Route path="Payroll/Payroll_Active/Release_Hold_Salary/Release_Hold_SalaryApp" element={<RELEASE_HOLD_SALARY/>}/>
        <Route path="Payroll/Payroll_Active/Salary_Increment/Salary_IncrementApp" element={<SALARY_INCREMENT/>}/>
        <Route path="Payroll/Leave_Resignation/Leave_Resign/Leave_ResignApp" element={<LEAVE_APPLICATION/>}/>
        <Route path="Payroll/Leave_Resignation/Compensatory_Leave/Compensatory_LeaveApp" element={<COMPENSATORY_LEAVE/>}/>
        <Route path="Payroll/Peformance/KPI_Master/KPI_MasterApp" element={<PAYROLL_KPI_MASTER/>}/>
        <Route path="Payroll/Peformance/KPI_Template/KPI_TemplateApp" element={<PAYROLL_KPI_TEMPLATE/>}/>
        <Route path="Payroll/Peformance/Assign_KPI_Employee/Assign_KPI_EmpApp" element={<PAYROLL_ASSIGN_KPI_EMP/>}/>
        <Route path="Payroll/Peformance/Emp_KPI_Entry/Emp_KPI_EntryApp" element={<PAYROLL_EMP_KPI_ENTRY/>}/>
        <Route path="Payroll/Peformance/Sup_KPI_Upd/Sup_KPI_UpdApp" element={<PAYROLL_SUP_KPI_UPDATE/>}/>
        <Route path="Payroll/Peformance/MD_KPI_Approval/MD_KPI_ApprApp" element={<PAYROLL_MD_KPI_APPROVAL/>}/>
        <Route path="Payroll/Peformance/MD_HM_Review/MD_HM_ReviewApp" element={<PERF_MD_HM_REVIEW/>}/>
        <Route path="Payroll/Peformance/HM_KPI_Approval/HM_KPI_ApprApp" element={<PAYROLL_HM_KPI_APPROVAL/>}/>

        <Route path="Payroll/Performacne_Reports/Performance_KPI/Rpt_Perf_KPI_App" element={<PROLL_PERFORM_RPT_KPI/>}/>
        <Route path="Payroll/Performacne_Reports/Emp_Daily_KPI/Rpt_Daily_KPI_App" element={<PP_RPT_DAILY_KPI_ENTRY/>}/>

        <Route path="Mobile_App/Notice/NoticeApp" element={<NOTICE_APP/>}/>
        <Route path="Mobile_App/Time_Table/Time_TableApp" element={<TIME_TABLE_APP/>}/>
        <Route path="Mobile_App/Home_Work/Home_WorkApp" element={<HOME_WORK_APP/>}/>
        <Route path="Mobile_App/Events/EventsApp" element={<EVENTS_APP/>}/>
        <Route path="Mobile_App/Awards/AwardApp" element={<AWARD_APP/>}/>
        <Route path="Mobile_App/Leave_Approval/Leave_ApprovApp" element={<LEAVE_APPROVAL/>}/>
        <Route path="Mobile_App/Appointment_Approval/Appointment_ApprovalApp" element={<APPOINTMENT_APPROVAL/>}/>
        <Route path="Mobile_App/Notes/NotesApp" element={<NOTES_APP/>}/>
        <Route path="Mobile_App/Remark/RemarkApp" element={<REMARK_APP/>}/>
        <Route path="Mobile_App/Create_Exam/Create_ExamApp" element={<CREATE_EXAM/>}/>
        <Route path="Marksheet_Module/Attendance_Period/Attendance_PeriodApp" element={<ATTENDANCE_PERIOD_APP/>}/>

       
        {/* <Route path="Student_Module/Student_Master/Edit/EditStudentApp" element={<STUD_MODULE_EDIT_STUDENT />}/> */}
        {/* <Route path="Student_Module/Student_Master/View/ViewStudentApp" element={<STUD_MODULE_VIEW_STUDENT />}/> */}
        {/* <Route path="Student_Module/Generate_RollNo/Generate_RollNoApp" element={<STUD_MODULE_GEN_ROLL />}/> */}
        
        {/*
        <Route path="masters/Maint_Comp/MaintCompApp" element={<MASTERS_MAINT_COMP_APP />}/>
        <Route path="masters/Prem_Types/PremTypesApp" element={<MASTERS_PREM_TYPES_APP />}/>
        <Route path="masters/Owner_Master/OwnerMstApp" element={<MASTERS_OWNER_APP />}/>
*/}
        {/* <Route path="masters/Addn_ChrgHead/AddnChrgHeadApp" element={<MASTERS_ADDN_CHRG_HEAD />}/>
        <Route path="masters/Rebate_Head/RebateHeadApp" element={<MASTERS_REBATE_HEAD />}/> */}
        
        {/* Master Reports */}
{/*
        <Route path="masters/Reports/List_Owners/ListOwnersApp" element={<MAST_RPT_OWNER_APP/>}/>
        <Route path="Maintenance/Maint_Struct/MaintStrctApp" element={<MAINT_STRUCT_APP />}/>
        <Route path="Maintenance/Maint_Rcpt/MaintRcptApp" element={<MAINT_RCPT_APP />}/>
        <Route path="Maintenance/Maint_Posting/MaintPostApp" element={<MAINT_POST_APP />}/>
        <Route path="Maintenance/Maint_Cancel/MaintCancApp" element={<MAINT_CANC_APP/>}/>
        <Route path="Maintenance/Addtn_Maint/AddtnMaintApp" element={<ADDTN_MAINT_APP/>}/>
        <Route path="Maintenance/Rebate_Alloc/AllocRebateApp" element={<ALLOC_REBATE_APP/>}/>
        <Route path="Maintenance/Parking_Alloc/AllocParkingApp" element={<ALLOC_PARKING_APP/>}/>
        <Route path="Maintenance/Reports/Pending_Maint/PendMaintApp" element={<RPT_PEND_MAINT_APP/>}/>
        <Route path="Maintenance/Reports/Maint_Register/MaintRegApp" element={<RPT_MAINT_REG_APP/>}/>
        <Route path="Maintenance/Reports/List_Maint_Struct/ListMaintStructApp" element={<LIST_MAINT_STRUCT_APP/>}/>
        <Route path="Maintenance/Reports/Alloted_Parking/RptAllotedParkApp" element={<RPT_ALLOT_PARK_APP/>}/>
        <Route path="Tenancy/Rental_Chrg/RentChrgApp" element={<RENTAL_CHRG_APP/>}/>
        <Route path="Tenancy/Rental_Agrmt/RentAgrmtApp" element={<RENTAL_AGRMNT_APP/>}/>
        <Route path="MobileApp/Notices/NoticeApp" element={<MOBAPP_NOTICE/>}/>
        <Route path="MobileApp/Reports/List_Notices/ListNoticesApp" element={<MOB_RPT_LST_NOTICE/>}/>
*/}
        {/* Finance */}
        <Route path="Finance/Masters/Group_Master/FinGroupApp" element={<FIN_GROUP_MST_APP/>}/>
        <Route path="Finance/Masters/SubGroup_Master/SubGroupApp" element={<FIN_SUBGRP_MST_APP/>}/>
        <Route path="Finance/Masters/CashBank_Master/CB_MasterApp" element={<FIN_CB_MST_APP/>}/>
        <Route path="Finance/Masters/Accnt_Master/AccntMasterApp" element={<FIN_ACCNT_MST_APP/>}/>
        <Route path="Finance/Masters/Budget_Master/BdgtMastApp" element={<FIN_BDGT_MAST_APP/>}/>

        <Route path="Finance/Transactions/Pay_Vchr/PayVchrApp" element={<FIN_PAY_VCHR_APP/>}/>
        <Route path="Finance/Transactions/Rcpt_Vchr/RcptVchrApp" element={<FIN_RCPT_VCHR_APP/>}/>
        <Route path="Finance/Transactions/JV_Vchr/JV_VchrApp" element={<FIN_JV_VCHR_APP/>}/>
        <Route path="Finance/Transactions/Contra_Vchr/ContraApp" element={<FIN_CONTRA_APP/>}/>
        <Route path="Finance/Transactions/Bank_Reco/bankRecoApp" element={<FIN_BANKRECO_APP/>}/>
        <Route path="Finance/Transactions/Budget_Alloc/BudgetAllocApp" element={<FIN_BUDALLOC_APP/>}/>

        {/* Finance Reports */}
        <Route path="Finance/Reports/ChartGrps/ChartGrpApp" element={<FIN_CHART_GRP_APP/>}/>
        <Route path="Finance/Reports/ChartAccnt/ChartAccntApp" element={<FIN_CHART_ACCNT_APP/>}/>
        <Route path="Finance/Reports/Day_Book/DayBookApp" element={<FIN_DAY_BOOK_APP/>}/>
        <Route path="Finance/Reports/CashBank_Book/CBBookApp" element={<FIN_CB_BOOK_APP/>}/>
        <Route path="Finance/Reports/Ledger/LedgerApp" element={<FIN_LEDGER_APP/>}/>
        <Route path="Finance/Reports/Trial_Balance/TrialBalApp" element={<FIN_TRIALBAL_APP/>}/>
        <Route path="Finance/Reports/Profit_Loss/ProfitLossApp" element={<FIN_PL_APP/>}/>
        <Route path="Finance/Reports/Bal_Sheet/BalSheetApp" element={<FIN_BS_APP/>}/>
        <Route path="Finance/Reports/Budget_Alloc/RptBgtAllocApp" element={<FIN_RPT_BGTALLOC_APP/>}/>
        <Route path="Finance/Reports/Detail_Budget/RptDtlBgtApp" element={<RPT_DETL_BGT_APP/>}/>

        <Route path="user_management/user_creation/User_MasterApp" element={<USER_MASTERAPP />}/>
        <Route path="user_management/role_creation/Role_MasterApp" element={<ROLE_MASTERAPP />}/>
        <Route path="user_management/change_password/ChangePassApp" element={<CHANGE_PASSAPP />}/>
        <Route path="user_management/reset_user_pass/Reset_PassApp" element={<RESET_PASSAPP />}/>

        <Route path="/dashboard" element={<Home />}/>
        
        
      </Routes>
    </div>
  );
}

export default MainPanel;
